var collapsible_list_component_rtlignore_default = {
  "ltr": "URH1F",
  "rtl": "_9TFgF",
  "iconContainer": "ehnch",
  "icon": "fMkt4",
  "isExpanded": "naS-k",
  "listDimensions": "_4As4V"
};
export {
  collapsible_list_component_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-component.rtlignore-scss.js.map
